import React from 'react';
import { HELP_ICON, HELP_AVATAR, HELP_AVATAR_2 } from '@screens/Onboarding/constants';
import { CardGlow } from '@screens/Onboarding/CardGlow';

/**
 * "You're going" drawer visual (QA 2026-07-26 §8, supersedes the copied
 * HelpRequestCard frame): the QUESTION renders as a white post card nested in
 * a tannish outer card, and the "I can help" exchange reads as a chat —
 * white rounded bubbles, each line with an avatar.
 */
export const GoingCelebrationIllustration: React.FC = () => (
  <div className="flex w-full flex-col items-center">
    <div className="relative w-full pb-3.25">
      <CardGlow />
      {/* 24px around the post card's 16px, 16px in: nearer concentric (32px) than equal radii,
          which pinch the corners, and near Figma's 20px. */}
      <div className="relative z-10 flex flex-col gap-3 rounded-3xl bg-[#f4efe4] px-4 py-4 shadow-[0_4px_20px_rgba(0,0,0,0.15)]">
        {/* The post: its own white card, like a real question in a feed */}
        <div className="flex flex-col gap-2.5 rounded-2xl bg-white px-4 py-3.5">
          <div className="flex items-center gap-2.5">
            <img
              src={HELP_AVATAR}
              alt=""
              aria-hidden="true"
              className="size-10.5 shrink-0 rounded-full object-cover"
            />
            <p className="text-base font-medium text-black">Catarina R.</p>
          </div>
          <p className="text-base font-semibold tracking-button text-black">
            Looking for Technical Co-Founders to Build the Next Generation of Human-Centric Digital
            Infrastructure
          </p>
          <div className="flex items-center justify-end gap-3">
            <div className="flex h-9.5 items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1">
              <span aria-hidden="true" className="text-lg">
                👋
              </span>
              <span className="text-sm text-black">Me too</span>
              <span className="text-sm font-medium text-black">12</span>
            </div>
            <div
              aria-hidden="true"
              className="flex h-9.5 items-center gap-1.5 rounded-full border border-mb-teal bg-mb-teal px-2.5 py-1"
            >
              <img src={HELP_ICON} alt="" aria-hidden="true" className="size-5.75 object-contain" />
              <span className="text-sm text-mb-ink">I can help</span>
              <span className="text-sm font-medium text-mb-ink">4</span>
            </div>
          </div>
        </div>

        {/* The exchange: chat bubbles, each with an avatar */}
        <div aria-hidden="true" className="flex flex-col gap-2.5">
          <div className="flex items-center justify-end gap-2">
            <div className="flex h-10.5 items-center gap-1.5 rounded-full bg-white px-3.5 py-1.5">
              <img src={HELP_ICON} alt="" className="size-5.5 object-contain" />
              <span className="text-sm font-medium text-black">I can help</span>
            </div>
            <img src={HELP_AVATAR_2} alt="" className="size-8 shrink-0 rounded-full object-cover" />
          </div>
          <div className="flex items-center gap-2">
            <img src={HELP_AVATAR} alt="" className="size-8 shrink-0 rounded-full object-cover" />
            <div className="flex h-10.5 items-center rounded-full bg-white px-3.5 py-1.5">
              <span className="text-sm text-black">Great, let&apos;s meet</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
